'use es6';

import Actions from 'AdsUI/lib/Actions';
import { List } from 'immutable';
const initialState = List();
export default ((state = initialState, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.ACCOUNTS_WITH_UNACCEPTED_TOS_FETCH_SUCCEEDED:
      return List(payload);

    case Actions.ACCEPT_AUDIENCE_TOS_FOR_ACCOUNTS_SUCCEEDED:
      return initialState;

    default:
      return state;
  }
});